import { render, staticRenderFns } from "./Canjear.vue?vue&type=template&id=1047cc50&scoped=true"
import script from "./Canjear.vue?vue&type=script&lang=js"
export * from "./Canjear.vue?vue&type=script&lang=js"
import style0 from "./Canjear.vue?vue&type=style&index=0&id=1047cc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1047cc50",
  null
  
)

export default component.exports